import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { resetService } from '../../reducers/serviceReducer';
import AddServiceForm from './addServiceForm';
import { FormType } from '../../constants/constants';

interface IAddServiceProps {
    classes: any;
    theme: Theme;
    match: any;
    resetService: any;
    steps: Array<number>;
    serviceId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetService: () => dispatch(resetService())
});

const mapStoreToProps = (store: RootState, ownProps: IAddServiceProps) => {
    return {
        serviceId: ownProps.match.params?.serviceId ? Number(ownProps.match.params?.serviceId) : undefined
    };
};

class AddService extends Component<IAddServiceProps> {
    componentWillUnmount() {
        const { resetService } = this.props;

        resetService();
    }

    render() {
        const { classes, steps, serviceId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <AddServiceForm serviceId={serviceId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddService));